import {Sequence} from 'components/Sequence';
import Protein from 'molbio/proteins/Protein';
import {PolymerTabState, PolymerTabStateAttributes} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

export type HistoryTabStateAttributes<Polymer extends Protein | Sequence> =
  PolymerTabStateAttributes<Polymer>;

interface HistoryTabState<Polymer extends Protein | Sequence> {
  get<K extends keyof HistoryTabStateAttributes<Polymer>>(key: K): HistoryTabStateAttributes<Polymer>[K];
  set<K extends keyof HistoryTabStateAttributes<Polymer>>(
    attributeName: K,
    value: HistoryTabStateAttributes<Polymer>[K],
    options?: Backbone.ModelSetOptions
  ): HistoryTabState<Polymer>;
  set(obj: Partial<HistoryTabStateAttributes<Polymer>>): HistoryTabState<Polymer>;
}

class HistoryTabState<Polymer extends Protein | Sequence> extends PolymerTabState<Polymer> {
  override defaults(): TabStateDefaults {
    return super.defaults();
  }
}

export default HistoryTabState;
